<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				调岗申请-{{ruleForm.id != null && ruleForm.id != '' ? '修改' : '新增'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
					<el-row>
						<el-col>
							<div @click="StaffFind">
								<el-form-item label="调岗人" prop="staff_name" style="margin-top:80px">
									<el-input style="width:50%" v-model="ruleForm.staff_name" onfocus="this.blur();">
									</el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row> 

					<el-row>
						<el-col>
							<el-form-item label="身份证号" prop="">
                                <el-input v-model="ruleForm.staff.staff_card" style="width:50%" :disabled="true"></el-input>
                            </el-form-item>
						</el-col>
					</el-row>
                    
                    <el-row>
                        <el-col>
                            <el-form-item label="现岗位" prop="">
                                <el-input v-model="ruleForm.staff.post_name" style="width:50%" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

					<el-row>
						<el-col>
							<el-form-item label="目标架构" prop="project_id" v-show="ruleForm.id == null || ruleForm.id == ''">
								<el-cascader v-model="ruleForm.organize_temporary_ids" @change="changeCascader" 
									style="width:50%" collapse-tags :props="props">
								</el-cascader>
                            </el-form-item>
                            <el-form-item label="目标架构" prop="project_id" v-show="ruleForm.id != null && ruleForm.id != ''">
                                <div style="border:1px solid #DCDFE6; width:48%;border-radius:5px;padding-left:10px;padding-right:10px">
                                    {{$globals.group_name + "/" + ruleForm.target_organize_name}}
                                </div>	
                            </el-form-item>
						</el-col>
					</el-row>

                    <el-row>
						<el-col>
							<el-form-item label="目标岗位" prop="post_id">
                                <el-select v-model="ruleForm.post_id" style="width:50%" placeholder="请选择" filterable
                                    clearable>
                                    <el-option v-for="item in ruleForm.gwlist" :key="item.id" :label="item.post_name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col>
							<el-form-item label="现薪酬" prop="">
                                <el-input v-model="ruleForm.nowSalary" style="width:50%" :disabled="true"></el-input>
                            </el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col>
							<el-form-item label="目标薪酬" prop="target_salary">
                                <el-input type="number" v-model="ruleForm.target_salary" style="width:50%"></el-input>
                            </el-form-item>
						</el-col>
					</el-row>

                    <el-row>
						<el-col >
							<el-form-item label="调岗说明" prop="transfer_explain">
                                <el-input type="textarea" :rows="2" placeholder="请输入调岗说明"
                                v-model="ruleForm.transfer_explain" style="width:50%"></el-input>
                        </el-form-item>
						</el-col>
					</el-row>


					<el-form-item style="margin-left:200px">
						<el-button type="goon" @click="Add" v-show="ruleForm.id == null || ruleForm.id == ''">保存
						</el-button>
						<el-button type="goon" @click="Update" v-show="ruleForm.id != null && ruleForm.id != ''">
							修改
						</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
		<el-dialog title="选择调岗人" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="true"
			:show-close="false" :modal-append-to-body="false" :append-to-body="true">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="6" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog> -->
	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	// import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
			// SelectAuditor: SelectAuditor,
		},
		props: ["organizeList"],
		data() {
            var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
                staffList: [],
                gwlist:[],
                dialogVisible: false,
                dialogVisibles:false,
                dialogAuditorVisible: false,
                ruleForm: {
                    id: '',
                    staff_id: '',
                    project_id: '',
                    project_name: '',
                    post_id: '',
                    post_name: '',
                    staff_name:'',
                    staff_card: '',
                    nowSalary: '',
                    target_salary: '',
                    transfer_explain: '',
                    examineDetailsList:[],
                    organize_temporary_ids: [],
                    gwlist:[],
                },
                //表单验证
                rules: {
					staff_name:[{
                        required: true,
                        message: '请选择调岗人！',
                        trigger: 'blur'
                    }],
                    post_id: [{
                        required: true,
                        message: '请选择目标岗位！',
                        trigger: 'blur'
                    }],
					project_id: [{
                        required: true,
                        message: '请选择目标架构！',
                        trigger: 'blur'
                    }],
                    target_salary: [{
                        required: true,
                        message: '请输入目标薪酬！',
                        trigger: 'blur'
                    }],
                    transfer_explain: [{
                        required: true,
                        message: '请输入调岗说明！',
                        trigger: 'blur'
                    }],
                },
                //级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
            };
		},
		methods: {
            
            //组织架构选择
			changeCascader() {
                this.ruleForm.project_id = this.ruleForm.organize_temporary_ids[this.ruleForm.organize_temporary_ids.length - 1];
                this.gwList();
            },
            //岗位
			async gwList() {
				var url = 'post/selectFind';
				var record = {
					organize_id: this.ruleForm.project_id,
				};
                var res = await this.$globals.AxiosPost(url, record);
                this.ruleForm.gwlist = res.data;
			},
			//获取
            StaffFind() {
                this.dialogVisibles = true;
                this.staffList.forEach(item => {
                    if (item.id === this.ruleForm.staff_id) {
                        this.ruleForm.staff.post_name = item.post_name;
                        this.ruleForm.staff.staff_card = item.staff_card;
                        this.ruleForm.staff.nowSalary = item.nowSalary;
                    }
                })
            },
            //设置确定
			saveChange(e) {
				this.ruleForm.staff_id = e.staff_id;
                this.ruleForm.staff_name = e.staff_name;
                this.ruleForm.staff.post_name = e.staff[0].post_name;
                this.ruleForm.staff.staff_card = e.staff[0].staff_card;
                this.ruleForm.staff.nowSalary = e.staff[0].nowSalary;
				this.dialogVisibles = false;
			},
            //添加
            
            Return() {
				this.dialogAuditorVisible = false;
				this.$parent.Return();
				this.$parent.Find();
				this.trash();
            },
            AddAuditor() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        // this.ruleForm.examineDetailsList = [];
                        // this.dialogAuditorVisible = true;
                        // this.$refs['SelectAuditor'].initialize();
						this.Add();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            async Add() {   
				var url = 'StaffTransfer/insert';
				var record = {
					project_id: this.ruleForm.project_id,
					staff_id: this.ruleForm.staff_id,
					post_id: this.ruleForm.post_id,
					applicant_id: this.$globals.user.id,
					target_salary: this.ruleForm.target_salary,
					transfer_explain:this.ruleForm.transfer_explain,
					// examineDetailsList:this.ruleForm.examineDetailsList,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						// this.Find();
						this.Return();
						return this.$globals.user.id;
					} else {
						this.$message.warning(data);
					}
				}
            },
            //修改
            UpdateAuditor() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        this.ruleForm.examineDetailsList = [];
                        this.dialogAuditorVisible = true;
                        this.$refs['SelectAuditor'].initialize();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            async Update() {
                var url = '/StaffTransfer/update';
                var record = {
                    id: this.ruleForm.id,
                    staff_id: this.ruleForm.staff_id,
                    post_id: this.ruleForm.post_id,
                    target_salary: this.ruleForm.target_salary,
                    transfer_explain: this.ruleForm.transfer_explain,
                    project_id:this.ruleForm.project_id,
                    // examineDetailsList: this.ruleForm.examineDetailsList,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.$parent.$parent.dialogVisible =  false;
                        this.dialogAuditorVisible = false;
                        this.$parent.$parent.Find();
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
		},
		async created() {

            // 岗位
            // var gwList = await this.$globals.AxiosPost("post/selectFind", {});
            // this.gwList = gwList.data;
            this.ruleForm = this.$parent.$parent.ruleForm;

			this.ruleForm = this.$parent.ruleForm;
		},
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Ygtg_add.vue?5d2cb8de